import React from 'react';
import classNames from 'classnames';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { makeStyles } from '@material-ui/core/styles';
import Check from '@material-ui/icons/Check';
import Remove from '@material-ui/icons/Remove';
import styles from 'assets/jss/material-dashboard-pro-react/components/customCheckboxStyle';

// @ts-ignore
const useStyles = makeStyles(styles);

type ICheckboxSizes = 'xs' | 'sm' | 'lg';

interface ICheckboxProps {
	className?: string;
	onClick: Function;
	checked: boolean;
	disabled?: boolean;
	tabIndex?: number;
	label?: string;
	indeterminate?: boolean;
	formControlProps?: object;
	checkboxProps?: object;
	disableLabel?: boolean;
	size?: ICheckboxSizes;
	labelProps?: object;
}

const CustomCheckbox = ({
	onClick,
	tabIndex,
	label,
	formControlProps,
	checkboxProps,
	checked,
	disabled,
	indeterminate,
	disableLabel,
	className,
	size = 'lg',
	labelProps,
}: ICheckboxProps) => {
	const classes = useStyles(labelProps);

	const checkedIconClasses = classNames({
		[classes.checkedIcon]: true,
		[classes.iconDisabled]: disabled,
	});

	const uncheckedIconClasses = classNames({
		[classes.uncheckedIcon]: true,
		[classes.uncheckedIconXs]: size === 'xs',
		[classes.iconDisabled]: disabled,
	});

	const indeterminateIconClasses = classNames({
		[classes.indeterminateIcon]: true,
		[classes.iconDisabled]: disabled,
	});

	const formControlLabelClasses = classNames({
		[classes.label]: true,
		[classes.labelChecked]: checked || indeterminate,
		[classes.labelCustomValues]: labelProps ? true : false,
	});

	const checkbox = (
		<Checkbox
			disabled={disabled}
			className={className}
			indeterminate={indeterminate}
			tabIndex={tabIndex}
			// @ts-ignore
			onClick={onClick}
			checked={checked}
			color="primary"
			checkedIcon={<Check className={checkedIconClasses} />}
			icon={<Check className={uncheckedIconClasses} />}
			indeterminateIcon={<Remove className={indeterminateIconClasses} />}
			classes={{
				checked: classes.checked,
				disabled: classes.disabledCheckboxAndRadio,
			}}
			{...checkboxProps}
		/>
	);

	return disableLabel ? (
		checkbox
	) : (
		<FormControlLabel
			disabled={disabled}
			control={checkbox}
			classes={{
				label: formControlLabelClasses,
				root: classNames({
					[classes.labelRoot]: true,
					[classes.rootSm]: size === 'sm',
					[classes.rootXs]: size === 'xs',
				}),
			}}
			label={label}
			{...formControlProps}
		/>
	);
};

export default CustomCheckbox;
